<template>
    <div class="ibox form">
        <div class="tabs-grey">
            <ul class="nav nav-tabs" role="tablist">
                <li v-if="getPermission('perm_view_aging-receivables-and-liabilities_receivables')">
                    <a
                        class="nav-link"
                        :class="tab == 'receivables' ? 'active' : ''"
                        href="#"
                        @click.prevent="changeTab('receivables')"
                    >
                        {{ __("receivables") }}
                    </a>
                </li>
                <li v-if="getPermission('perm_view_aging-receivables-and-liabilities_liability')">
                    <a
                        class="nav-link"
                        :class="tab == 'liabilities' ? 'active' : ''"
                        href="#"
                        @click.prevent="changeTab('liabilities')"
                    >
                        {{ __("liabilities") }}
                    </a>
                </li>
            </ul>
        </div>

        <div  v-if="(tab == 'receivables' && getPermission('perm_view_aging-receivables-and-liabilities_receivables'))
        || (tab == 'liabilities' && getPermission('perm_view_aging-receivables-and-liabilities_liability'))" class="ibox-title ibox-grey" style="border-top:0px;">
            <h4>{{ __(tab) }}</h4>
            <button-open-help-modal v-bind:helpName="helpName"/>
        </div>


        <div class="ibox-content">
            <div class="scroll-table">
                <div class="table-responsive text-nowrap">
                    <receivables-table
                        v-if="tab == 'receivables' && getPermission('perm_view_aging-receivables-and-liabilities_receivables')"
                        :liabilities="receivables"
                        :permission_access="permission_access"
                        :documentScanRoute="documentScanRoute"
                        :documentPdfRoute="documentPdfRoute"
                        :previewRoute="previewRoute"
                        :previewReturnRoute="previewReturnRoute"
                        ref="receivables_table"
                        :tab="'receivables'"
                    />

                    <receivables-table
                        v-if="tab == 'liabilities' && getPermission('perm_view_aging-receivables-and-liabilities_liability')"
                        :liabilities="liabilities"
                        :documentScanRoute="documentScanRoute"
                        :permission_access="permission_access"
                        :documentPdfRoute="documentPdfRoute"
                        :previewRoute="previewRoute"
                        :previewReturnRoute="previewReturnRoute"
                        ref="receivables_table"
                        :tab="'liabilities'"
                    />
                </div>
            </div>
        </div>
        <div class="ibox-content">
            <bulk-action-button
                :disabled="exportDisabled"
                v-if="getPermission('perm_view_export_aging-receivables-and-liabilities') && !exportDisabled"
                :url="bulkUrl"
                :table="tab"
                :ids="bulkselectedPayments()"
                :main_ids="mainIds"
                param="ids"
                :data="formData"
            />
            <div v-if="getPermission('perm_view_export_aging-receivables-and-liabilities') && exportDisabled">
                {{ __('with_selected') }}:
                <button data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle" disabled="">
                    {{ __('export') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>
import ReceivablesTable from "./aging-tables/ReceivablesTable";
import BulkActionButton from "./table/BulkActionButton";
import { mapGetters, mapActions } from "vuex";
import permissions from './../services/Permissions.js';
import HelpModal from './help/HelpModal.vue';
import ButtonOpenHelpModal from './help/ButtonOpenHelpModal.vue';

export default {
    name: "receivables-and-liabilities-section",
    components: {
        ReceivablesTable,
        BulkActionButton,
        HelpModal,
        ButtonOpenHelpModal
    },
    data() {
        return {
            bulkUrl: "/summaries/receivables-and-liabilities/bulk-action",
            helpName: ""
        };
    },

    props: {
        liabilities: {
            type: Array,
            default: null
        },
        receivables: {
            type: Array,
            default: null
        },
        documentScanRoute: {
            type: String,
            default: "#"
        },
        documentPdfRoute: {
            type: String,
            default: "#"
        },
        previewRoute: {
            type: String,
            default: "#"
        },
        previewReturnRoute: {
            type: String,
            default: "#"
        },
        tabSelected: {
            type: String
        },
        permission_access: {
            default: null
        }
    },
    watch:{
        tabSelected (value) {
            this.setHelpName(value);
        }
    },
    computed: {
        mainIds :function() {
            return this.$props[this.tab].map( item  => { return item.payment.id});
        },
        formData: function() {
            return {
                tab: 'liabilities',
                currency: this.currency,
                date: this.inputDate ? this.inputDate : "",
                intervals: this.intervalsSettings.intervals
            };
        },
        tab: {
            get: function() {
                return this.tabSelected;
            },
            set: function(newValue) {
                this.$emit("changeTab", newValue);
            }
        },
        ...mapGetters({
            selectedPayments: "getSelectedPayments",
            currency: "getCurrency",
            intervalsSettings: "getIntervalsSettings",
            inputDate: "getDate"
        }),
        exportDisabled: function (){
            const _this = this;
            let hasAccess = true;
            let ids = [];
            if (this.tab == "receivables") {
                ids = this.receivables.map(item => item.payment.id);
            } else {
                ids = this.liabilities.map(item => item.payment.id);
            }
            if(ids.length == 0){
                return false;
            }
            let items = [];
            if (this.tab == "receivables") {
                 items  = this.receivables.filter(function (item){
                    return ids.includes(item.payment.id)
                });
            } else {
                 items = this.liabilities.filter(function (item){
                    return ids.includes(item.payment.id)
                });
            }
            items.forEach(item => {
                if(!item.has_access_export !== undefined && !item.has_access_export){
                    hasAccess = false;
                }
            })
            if(hasAccess){
                return false;
            }
            else{
                return true;
            }
        }
    },
    methods: {
        getPermission(permission) {
            return permissions.getPermission(this.permission_access, permission)
        },
        changeTab(val) {
            if(this.$refs.receivables_table) {
                this.$refs.receivables_table.clearSelected();
                this.deleteAllSelected();
            }
            this.tab = val;
            this.$emit("changeTab", val);
        },
        bulkselectedPayments() {
            let ids = [];
            if (this.selectedPayments.length > 0) {
                ids = this.selectedPayments;
            } else if (this.tab == "receivables") {
                ids = this.receivables.map(item => item.payment.id);
            } else {
                ids = this.liabilities.map(item => item.payment.id);
            }
            return ids;
        },
        setHelpName(tabSelected) {
            if(tabSelected == 'receivables')
                this.helpName = 'ZRN-002';
            if(tabSelected == 'liabilities')
                this.helpName = 'ZRN-004';
        },
        ...mapActions(["deleteAllSelected"])
    },
    mounted: function() {
        this.mainIds;
        this.setHelpName(this.tabSelected);
     },
};
</script>
